import { actionSpinnerClose, actionSpinnerOpen } from '@qadra/frontend-common/redux/actions';
import { call, takeEvery, put } from '@qadra/frontend-common/redux-saga';
import { CONFIRM_EMAIL } from '../actions';
import { apiConfirmEmailPost } from '../api';

function* confirmEmail({ payload }) {
  try {
    yield put(actionSpinnerOpen());

    const { error, success } = yield call(apiConfirmEmailPost, payload);

    if (error) {
      yield put({
        type: CONFIRM_EMAIL._ERROR,
        error,
      });
      yield put(actionSpinnerClose());
    } else if (success) {
      yield put({
        type: CONFIRM_EMAIL._SUCCESS,
        success,
      });
    }
    yield put(actionSpinnerClose());
  } catch (error) {
    yield put({
      type: CONFIRM_EMAIL._ERROR,
      error,
    });
    yield put(actionSpinnerClose());
  }
}

function* watchConfirmEmail() {
  yield takeEvery(CONFIRM_EMAIL._REQUEST, confirmEmail);
}

const array = [watchConfirmEmail];
export default array;
